import { useEffect, useState } from "react";
import api from "../utils/api";

export default function AdminAutoTrades() {
    const [logs, setLogs] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [userFilter, setUserFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const currentUser =
        localStorage.getItem("email") ||
        localStorage.getItem("user_id") ||
        localStorage.getItem("trader_id");

    const load = async (pageNum = 1) => {
        setLoading(true);
        setError("");
        try {
            const { data } = await api.get("/api/admin/auto-trades", {
                params: {
                    page: pageNum,
                    limit: 50,
                    user_id: userFilter || undefined,
                    current_user: currentUser,
                },
            });
            if (!data.ok) {
                setError(data.error || "Failed to load logs.");
                setLogs([]);
                setPages(1);
            } else {
                setLogs(data.results || []);
                setPages(data.pages || 1);
                setPage(data.page || pageNum);
            }
        } catch (e) {
            setError(e?.response?.data?.error || e.message || "Request failed");
            setLogs([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (currentUser) {
            load(1);
        }
    }, [currentUser]);

    const handleApply = () => load(1);

    return (
        <div className="p-6 space-y-4">
            <h1 className="text-2xl font-bold text-zinc-100">
                Auto-Trade Logs (Admin)
            </h1>

            <div className="flex flex-wrap gap-2 items-end">
                <div>
                    <label className="block text-xs text-zinc-400 mb-1">
                        Filter by user_id (optional)
                    </label>
                    <input
                        value={userFilter}
                        onChange={(e) => setUserFilter(e.target.value)}
                        className="bg-zinc-900 border border-zinc-700 rounded px-2 py-1 text-sm text-zinc-100"
                        placeholder="email or user id"
                    />
                </div>
                <button
                    onClick={handleApply}
                    className="bg-blue-600 hover:bg-blue-500 text-sm px-3 py-1 rounded"
                >
                    Apply
                </button>
            </div>

            {error && <div className="text-sm text-red-400">{error}</div>}

            {loading ? (
                <div className="text-sm text-zinc-400">Loading�</div>
            ) : logs.length === 0 ? (
                <div className="text-sm text-zinc-400">No auto-trades logged yet.</div>
            ) : (
                <div className="overflow-auto border border-zinc-800 rounded-lg">
                    <table className="min-w-full text-xs text-zinc-200">
                        <thead className="bg-zinc-900">
                            <tr>
                                <th className="px-2 py-1 text-left">Time</th>
                                <th className="px-2 py-1 text-left">User</th>
                                <th className="px-2 py-1 text-left">Broker</th>
                                <th className="px-2 py-1 text-left">Asset</th>
                                <th className="px-2 py-1 text-left">Symbol</th>
                                <th className="px-2 py-1 text-left">Qty</th>
                                <th className="px-2 py-1 text-left">Side</th>
                                <th className="px-2 py-1 text-left">Strategy</th>
                                <th className="px-2 py-1 text-left">Source</th>
                                <th className="px-2 py-1 text-left">Status</th>
                                <th className="px-2 py-1 text-left">Error</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log) => (
                                <tr key={log.id} className="border-t border-zinc-800">
                                    <td className="px-2 py-1 whitespace-nowrap">
                                        {log.created_at}
                                    </td>
                                    <td className="px-2 py-1">{log.user_id}</td>
                                    <td className="px-2 py-1">{log.broker}</td>
                                    <td className="px-2 py-1">{log.asset_type}</td>
                                    <td className="px-2 py-1">
                                        {log.symbol}
                                        {log.option_symbol ? (
                                            <>
                                                <br />
                                                <span className="text-[0.65rem] text-zinc-400">
                                                    {log.option_symbol}
                                                </span>
                                            </>
                                        ) : null}
                                    </td>
                                    <td className="px-2 py-1">{log.qty}</td>
                                    <td className="px-2 py-1">{log.side}</td>
                                    <td className="px-2 py-1">{log.strategy}</td>
                                    <td className="px-2 py-1">{log.source}</td>
                                    <td
                                        className={`px-2 py-1 ${log.status === "success"
                                                ? "text-emerald-400"
                                                : "text-red-400"
                                            }`}
                                    >
                                        {log.status}
                                    </td>
                                    <td className="px-2 py-1 max-w-xs truncate" title={log.error}>
                                        {log.error}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <div className="flex items-center gap-2 text-xs text-zinc-400">
                <button
                    disabled={page <= 1}
                    onClick={() => load(page - 1)}
                    className="px-2 py-1 border border-zinc-700 rounded disabled:opacity-40"
                >
                    Prev
                </button>
                <span>
                    Page {page} / {pages}
                </span>
                <button
                    disabled={page >= pages}
                    onClick={() => load(page + 1)}
                    className="px-2 py-1 border border-zinc-700 rounded disabled:opacity-40"
                >
                    Next
                </button>
            </div>
        </div>
    );
}
